import { NgModule,enableProdMode} from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
/**后者添加 */
import { Camera } from '@ionic-native/camera/ngx';//照相机
import { ImagePicker } from '@ionic-native/image-picker/ngx';//相册获取照片
import { Device } from '@ionic-native/device/ngx';//硬件设备
import {HttpClientModule } from '@angular/common/http';
import {FormsModule} from '@angular/forms';
import {BaseModal} from '../model/base';
import { AppConfig} from '../app/app.config';
import { BarcodeScanner } from '@ionic-native/barcode-scanner/ngx';//扫描二维码
import { ScreenOrientation } from '@ionic-native/screen-orientation/ngx';//禁止手机横屏
import { AppUpdate } from '@ionic-native/app-update/ngx';//android更新版本
import { Sim } from '@ionic-native/sim/ngx'; //获取sim卡信息
import { Base64 } from '@ionic-native/base64/ngx';//转换成64位
import { FileTransfer  } from '@ionic-native/file-transfer/ngx';//上传图片
import { HashLocationStrategy,LocationStrategy} from '@angular/common';
import { Geolocation } from '@ionic-native/geolocation/ngx';
import { File } from "@ionic-native/file/ngx";
import { Keyboard } from '@ionic-native/keyboard/ngx';
import { AppVersion } from '@ionic-native/app-version/ngx';
import { InAppBrowser } from '@ionic-native/in-app-browser/ngx';
import { FileOpener} from '@ionic-native/file-opener/ngx';
import { SQLite } from '@ionic-native/sqlite/ngx';//本地数据缓存
// import { SQLite } from '@ionic-native/sqlite/ngx';//本地数据缓存

import { ModalpagePageModule } from "./modalpage/modalpage.module";
import { PublicselectionPageModule } from "./publicselection/publicselection.module";
import {CodelessSalsePageModule} from './codeless-salse/codeless-salse.module'; // 无码销量弹窗
import{CodelessReturnslistPageModule} from './codeless-returnslist/codeless-returnslist.module'; // 无码退货
import { PotentialMemberslistPageModule } from "./components/nestle-crm/potential-memberslist/potential-memberslist.module";
import { SelectionpagePageModule} from  "./selectionpage/selectionpage.module";
import { SchedulingapprovalPageModule} from "./schedulingapproval/schedulingapproval.module";
import {EmitserviceService} from 'src/service/emitservice.service';
import { GaoDeLocation } from '@ionic-native/gao-de-location/ngx';
import { MzModalPageModule } from './page/nestle/mz-modal/mz-modal.module';
import { StoreListPageModule } from "./store-list/store-list.module";
import { GiftAuditModalPageModule } from './page/nestle/gift-audit-modal/gift-audit-modal.module';
import { CommunicationRecordsPageModule } from "./components/nestle-crm/communication-records/communication-records.module";
import { PotentialMembersdetailPageModule } from "./components/nestle-crm/potential-membersdetail/potential-membersdetail.module";
import { QrcodeGroupPageModule } from "./components/nestle-crm/qrcode-group/qrcode-group.module";
import { SearchModalPageModule } from "./components/nestle-crm/content-library/search-modal/search-modal.module";
import {TechniqueDescribedPageModule} from "src/app/components/nestle-crm/technique-described/technique-described.module";
import {ReasonsDifferencesPageModule} from "src/app/components/reasons-differences/reasons-differences.module"
import{ButtonSelectionPageModule} from './button-selection/button-selection.module'; // 弹窗选择退货有无码
import{ListofActivitiesPageModule} from 'src/app/components/listof-activities/listof-activities.module';
// import { MzModalPage } from './page/nestle/mz-modal/mz-modal.page';
import { MzModalpagePageModule } from "./plugin/mz-modalpage/mz-modalpage.module";
// import {HttpCustomerService,SignalrclientService,MapclientServiceService,MessageclientService,UploadHotService,SqliteServicesService,StaticService,NativeService,WxjssdkService}from 'src/service/index';


enableProdMode();
@NgModule({
  declarations: [AppComponent],
  entryComponents: [],
  imports: [BrowserModule, BrowserAnimationsModule,FormsModule,HttpClientModule,IonicModule.forRoot({swipeBackEnabled:false,animated:false,scrollAssist:false,mode:'ios'}), AppRoutingModule,ModalpagePageModule,PublicselectionPageModule,SelectionpagePageModule,SchedulingapprovalPageModule
  ,MzModalPageModule,StoreListPageModule
  ,GiftAuditModalPageModule
  ,PotentialMemberslistPageModule
  ,CommunicationRecordsPageModule
  ,PotentialMembersdetailPageModule
  ,QrcodeGroupPageModule
  ,SearchModalPageModule,
  TechniqueDescribedPageModule,
  CodelessSalsePageModule,
  CodelessReturnslistPageModule,
  ButtonSelectionPageModule,
  ReasonsDifferencesPageModule,
  ListofActivitiesPageModule,
  MzModalpagePageModule
  ],
  providers: [
    // HttpCustomerService,
    StatusBar,
    Camera,
    ImagePicker,
    Device,
    SplashScreen,
    BarcodeScanner,
    ScreenOrientation,
    AppUpdate,
    BaseModal,
    AppConfig,
    Geolocation,
    Sim,
    AppVersion,
    Base64,
    FileTransfer,
    InAppBrowser,
    File,
    Keyboard,
    FileOpener,
    SQLite,
    GaoDeLocation,
    EmitserviceService,
    {provide: LocationStrategy, useClass: HashLocationStrategy},
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
